import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MobilePage from "../components/MobilePage";
import Testimonials from "../components/Testimonials";
import MainPage from "../components/Home/MainPage";
import BestSellers from "../components/Home/BestSellers";
import axios from "axios";
import ScrollTop from "../components/ScrollTop";
import ExplorProducts from "../components/Home/ExplorProducts";

const Home = ({ restaurants }) => {
  const [welcome, setWelcome] = useState({});

  const { restaurant, id } = useParams();

  const formattedRestaurant = restaurant.replace(/([a-z])([A-Z])/g, "$1 $2");

  const getWelcomeHere = async () => {
    try {
      const res = await axios.post(
        `https://partnermeatwala.com/api/Vendor/GetVendorWelcomeMessage`,
        { pkid: id }
      );
      setWelcome(res?.data?.result);
    } catch (error) {}
  };

  useEffect(() => {
    getWelcomeHere();
  }, []);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    const decodedText = txt.value;

    const strippedText = decodedText.replace(/<\/?[^>]+(>|$)/g, "");
    return strippedText;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />{" "}
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>

      <MainPage />

      <section className="space bg-smoke2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-md-8">
              <div className="title-area text-center">
                <h2 className="sec-title text-white">
                  Welcome to <br /> {formattedRestaurant}
                </h2>
              </div>
            </div>

            <div className="col-xl-12 text-center">
              <p className="text-white">{decodeHtml(welcome?.message)}</p>
            </div>
          </div>
        </div>
      </section>
      <BestSellers />
      <section className="bg-top-center overflow-hidden pb-5 pt-5 bg-lighter">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-md-8">
              <div className="title-area text-center">
                <h2 className="sec-title">How It Works</h2>
              </div>
            </div>
          </div>
          <div className="deal-sec-area">
            <div className="row">
              <div className="col-lg-3 mb-3">
                <div
                  className="text-center pt-2 bg-smoke2"
                  style={{
                    border: "1px solid #e13e3e",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    height: "315px",
                    borderRadius: "20px",
                  }}
                >
                  <img src="../assets/img/order.png" />
                  <br />
                  <br />
                  <h5 className="text-white">Order Online</h5>
                  <p className="text-white">
                    Browse our selection, add your favourite cuts to the basket,
                    and place your order in minutes.
                  </p>
                </div>s
              </div>
              <div className="col-lg-3 mb-3">
                <div
                  className="text-center pt-2 bg-smoke2"
                  style={{
                    border: "1px solid #e13e3e",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    height: "315px",
                    borderRadius: "20px",
                  }}
                >
                  <img src="../assets/img/cut.png" />
                  <br />
                  <br />
                  <h5 className="text-white">Butchers Prepare</h5>
                  <p className="text-white">
                  Our expert butchers cut, trim and pack your meat fresh, ensuring top quality every time.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 mb-3">
                <div
                  className="text-center pt-2 bg-smoke2"
                  style={{
                    border: "1px solid #e13e3e",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    height: "315px",
                    borderRadius: "20px",
                  }}
                >
                  <img src="../assets/img/ship.png" />
                  <br />
                  <br />
                  <h5 className="text-white">We Deliver</h5>
                  <p className="text-white">
                  Your order is securely packed and delivered straight to your door, fresh and in minutes.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 mb-3">
                <div
                  className="text-center pt-2 bg-smoke2"
                  style={{
                    border: "1px solid #e13e3e",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    height: "315px",
                    borderRadius: "20px",
                  }}
                >
                  <img src="../assets/img/enjoy.png" />
                  <br />
                  <br />
                  <h5 className="text-white">Cook & Enjoy</h5>
                  <p className="text-white">
                  Prepare your favourite dishes and enjoy fresh, delicious halal meat, Taste the difference.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ExplorProducts />
      <Testimonials restaurants={restaurants} />
      <MobilePage />
      <ScrollTop />
    </section>
  );
};

export default Home;
